import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {FLowTemplate} from '@features/eat/models/flow.model';
import {FormBuilder, Validators} from '@angular/forms';

@Component({
    standalone: false,
    selector: 'app-create-eat-workflow-dialog',
  templateUrl: './create-eat-workflow-dialog.component.html',
  styleUrls: ['./create-eat-workflow-dialog.component.scss']
})
export class CreateEatWorkflowDialogComponent implements OnInit, OnDestroy {

  inputForm: any;
  data: DialogModel;
  templates: FLowTemplate[];
  formChangesSubscription: any;
  private singleExecution: boolean;

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.templates = this.data.input.templates;
    this.inputForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: []
    });
    this.data.isDisabledOkButton = true;
    this.formChangesSubscription = this.inputForm.valueChanges.subscribe(() => {
      this.data.isDisabledOkButton = this.inputForm.invalid;
    });
  }

  onOkClicked(): boolean {
    if (this.inputForm.controls['title'].value) {
      this.data.input['title'] = this.inputForm.controls['title'].value;
    }
    if (this.inputForm.controls['description'].value) {
      this.data.input['description'] = this.inputForm.controls['description'].value;
    }
    this.data.input['singleExecution'] = this.singleExecution;
    return true;

  }

  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }

  onSingleExecutionSelectionChange(checked: boolean) {
    this.singleExecution = checked;
  }
}
